// extracted by mini-css-extract-plugin
export default {"custom-font-container":"styles_custom-font-container__lqxp2","custom-font":"styles_custom-font__fIPKo"};